export const AUCUN = 'Aucun';
export const BLOQUE = 'Bloque';
export const BLOQUE_COMMANDE = 'BloqueCommande';
export const OPTION = 'Option';
export const SANS_SUITE = 'SansSuite';
export const ANNULATION = 'Annulation';
export const INDISPONIBLE = 'Indisponible';
export const RELANCE_OPTION = 'RelanceOption';
export const EN_ATTENTE_RELANCE_OPTION = 'AttenteRelanceOption';
export const ATTENTE_REPONSE = 'AttenteReponse';
export const LIGNE_CMD_SEL_TYPE_SEMAINE = 'Semaine';
export const LIGNE_CMD_SEL_TYPE_PERIODE = 'Periode';

export const ETAT_SOUHAITE = [
  { key: AUCUN, libelle: 'optionBlocage.aucun' },
  { key: BLOQUE, libelle: 'optionBlocage.bloque' },
  { key: OPTION, libelle: 'optionBlocage.option' },
  { key: SANS_SUITE, libelle: 'optionBlocage.sansSuite' },
  { key: ANNULATION, libelle: 'optionBlocage.annulation' },
];

export const ETAT_OBTENU = [
  { key: AUCUN, libelle: 'optionBlocage.aucun' },
  { key: BLOQUE, libelle: 'optionBlocage.bloque' },
  { key: BLOQUE_COMMANDE, libelle: 'optionBlocage.bloque' },
  { key: OPTION, libelle: 'optionBlocage.option' },
  { key: INDISPONIBLE, libelle: 'optionBlocage.indisponible' },
  { key: SANS_SUITE, libelle: 'optionBlocage.sansSuite' },
  { key: ANNULATION, libelle: 'optionBlocage.annulation' },
  { key: EN_ATTENTE_RELANCE_OPTION, libelle: 'optionBlocage.enAttente' },
  { key: RELANCE_OPTION, libelle: 'optionBlocage.relanceOption' },
];

export const ETAT_OBTENU_REPONSE = [
  { key: ATTENTE_REPONSE, libelle: 'optionBlocage.attenteReponse' },
  { key: AUCUN, libelle: 'optionBlocage.aucun' },
  { key: BLOQUE, libelle: 'optionBlocage.bloque' },
  { key: OPTION, libelle: 'optionBlocage.option' },
  { key: INDISPONIBLE, libelle: 'optionBlocage.indisponible' },
  { key: SANS_SUITE, libelle: 'optionBlocage.sansSuite' },
  { key: ANNULATION, libelle: 'optionBlocage.annulation' },
  { key: EN_ATTENTE_RELANCE_OPTION, libelle: 'optionBlocage.enAttente' },
];

export const LIBRE = 'Libre';
export const LIBRE_OPTION = 'LibreOption';
export const LIBRE_OPTION_VENDU = 'LibreOptionVendu';

export const NIVEAU_DISPONIBILITE = [
  { key: LIBRE, libelle: 'optionBlocage.libre' },
  { key: LIBRE_OPTION, libelle: 'optionBlocage.libreOption' },
  { key: LIBRE_OPTION_VENDU, libelle: 'optionBlocage.libreOptionVendu' },
];
